export const PAGE_DEFAULT = { name: 'tableau-de-bord' };
